import { handleActions } from 'redux-actions';

import { NAMES as GET_EXPERIMENTS } from 'shared/redux/server/actions/experiments/get';


const defaultExperiments = {
  enableMemberOnlyExp: 'false',
  enableUpgradeCounterPanelExp: 'false',
  enableSubscriptionOnlyExp: 'false',
  enableDrive: 'false',
  enableDropbox: 'false',
  videoCoverMultiselect: 'false',
  enableBatchEdit: 'false',
  hideVideoTitleOnMainItem: 'false',
  compactLayout: 'false',
  newPlayer: 'false',
};


export default handleActions({
  [GET_EXPERIMENTS.SUCCESS]: (state, { payload: { response } }) => ({ ...defaultExperiments, ...response }),
  [GET_EXPERIMENTS.FAIL]: _.constant(defaultExperiments),
}, null);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/experiments.js